import React, { useState } from 'react'
import {
  Header as BrHeader,
  ContextBar,
  Logo,
} from '@vwfs-bronson/bronson-react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import ContactPageModal from '../../pages/ContactPageModal'
import gebrauchtwagenLogo from '../../resources/images/logos/VWFS_SOB_Picto_Gebrauchtwagen_RGB_1row_left_aligned.svg'
import { isVWFS, isVtiGiS } from '../../services/common/utils'
import { getStorefrontData } from '../../services/redux/features/storefront.redux'

export type HeaderProps = {}

const Header = () => {
  const [showContact, setShowContact] = useState(false)
  const { t } = useTranslation()
  const storefrontData = useSelector(getStorefrontData)

  const bronsonVersion = process.env.REACT_APP_WEBSITE_BRONSON_VERSION;

  return (
    <>
      <BrHeader
        testId="appHeader"
        staticHeader
        logo={
          <div style={{ display: 'flex', maxHeight: '70px' }}>
            <Logo
              ariaLabel='Volskwagen Financial Services Logo'
              testId="appHeaderLogo"
              tabIndex={0}
              src={`https://cdn.bronson.vwfs.io/${process.env.REACT_APP_WEBSITE_BRONSON_THEME || 'bluelabel'}/v/${bronsonVersion}/img/logo.svg`}
              srcSmall={`https://cdn.bronson.vwfs.io/${process.env.REACT_APP_WEBSITE_BRONSON_THEME || 'bluelabel'}/v/${bronsonVersion}/img/logo-small-screen.svg`}
              alt="Volskwagen Financial Services Logo"
            />
            {isVWFS() && isVtiGiS(storefrontData) && (
              <img src={gebrauchtwagenLogo} alt="VW FS Gebrauchtwagen Logo" style={{ width: '50%' }} />
            )}
          </div>
        }
      >
        <ContextBar
          style={{
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <ContextBar.SiteNav>
            <ContextBar.SiteNav.Item>
              <ContextBar.SiteNav.Item.ContextItem
                contextBarIcon='semantic-chat'
                href='/'
                onClick={(e) => {
                  e.preventDefault()
                  setShowContact(true)
                }}
                iconLabel={t('contact:labelTitle')}
              />
            </ContextBar.SiteNav.Item>
          </ContextBar.SiteNav>
        </ContextBar>
      </BrHeader>

      <ContactPageModal
        testId="appContactPageModal"
        visible={showContact}
        onClose={() => setShowContact(false)}
      />
    </>
  )
}

export default Header
